import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../../../api';
import { AuthService } from '../../../services';
import CommonTitle from '../../../components/common-title/CommonTitle';

function SignupPC() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    termsAgreed: false,
    privacyAgreed: false,
    name: '',
    userId: '',
    password: '',
    confirmPassword: '',
    columbarium: 'family',
    emailPrefix: '',
    emailDomain: '',
    emailDomainSelect: '',
    gender: '남',
    birthDate: '',
    contact: '',
    mobilePrefix: '010',
    mobileMiddle: '',
    mobileEnd: '',
    address: '',
    addressDetail1: '',
    addressDetail2: '',
    postCode: ''
  });
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [idCheckLoading, setIdCheckLoading] = useState(false);
  const [idCheckResult, setIdCheckResult] = useState("");
  const [isDuplicateChecked, setIsDuplicateChecked] = useState(false);
  
  // Single alert function for validation messages
  const showValidationAlert = (message) => {
    alert(message);
  };
  
  const [places, setPlaces] = useState([
    { id: 1, name: "가족묘" },
    { id: 2, name: "봉안담" },
    { id: 3, name: "봉안당 A관" },
    { id: 4, name: "봉안당 S관" },
    { id: 5, name: "봉안당 하늘관" },
    { id: 6, name: "봉안당 햇빛관" },
    { id: 7, name: "야외가족납골당" }
  ]);

  // Password validation helper function
  const isPasswordValid = (password) => {
    if (!password) return false;
    if (password.length < 6 || password.length > 10) return false;
    // Allow alphanumeric and special characters
    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
    return passwordRegex.test(password);
  };

  // Helper function to check if phone contains combination of English letters and numbers
  const isAlphanumericCombination = (phone) => {
    // Must contain both letters and numbers, and only letters and numbers
    const hasLetter = /[a-zA-Z]/.test(phone);
    const hasNumber = /\d/.test(phone);
    const onlyAlphanumeric = /^[a-zA-Z0-9]+$/.test(phone);
    return hasLetter && hasNumber && onlyAlphanumeric;
  };

  // Form validation based on Java backend requirements
  const validateForm = () => {
    const newErrors = {};

    // Step 1 validation (Terms and Name)
    if (currentStep === 1) {
      if (!formData.termsAgreed) {
        newErrors.termsAgreed = '이용약관에 동의해주세요.';
        setErrors(newErrors);
      }
      if (!formData.privacyAgreed) {
        newErrors.privacyAgreed = '개인정보 수집·이용에 동의해주세요.';
        setErrors(newErrors);
      }
      if (!formData.name.trim()) {
        newErrors.name = '이름을 입력해주세요.';
        setErrors(newErrors);
      } else if (formData.name.length < 2) {
        newErrors.name = '이름은 2자 이상 입력해주세요.';
        setErrors(newErrors);
      } else {
        // Korean characters only validation
        const koreanRegex = /^[가-힣]+$/;
        if (!koreanRegex.test(formData.name.trim())) {
          newErrors.name = '이름은 한글만 입력해주세요.';
          setErrors(newErrors);
        }
      }
    }

    // Step 2 validation (Personal Information) - Based on Java @Valid annotations
    if (currentStep === 2) {
      // @NotBlank - User ID validation
      if (!formData.userId?.trim()) {                                           
        showValidationAlert('아이디를 입력해주세요. (6~20자 영문, 숫자 사용 가능)');
        return false;
      } else if (formData.userId.length < 6 || formData.userId.length > 20) {
        showValidationAlert('아이디를 입력해주세요. (6~20자 영문, 숫자 사용 가능)');
        return false;
      } else if (!isDuplicateChecked) {
        showValidationAlert('아이디 중복확인을 해주세요.');
        return false;
      }
      
  


    if (!formData.password) {
      showValidationAlert('비밀번호를 입력해주세요. (6~10자 영문, 숫자, 특수기호 사용 가능)');
      return;
    } else if (!isPasswordValid(formData.password)) {
      showValidationAlert('비밀번호를 입력해주세요. (6~10자 영문, 숫자, 특수기호 사용 가능)');
      return;
    }
    
    if (formData.password && !formData.confirmPassword) {
      showValidationAlert('비밀번호 확인을 해주세요.');
      return false;
    }
   if (formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword) {
    showValidationAlert('비밀번호가 일치하지 않습니다.');
    return;
    }
      
      // @Email - Email validation (required)
   if (!formData.emailPrefix || !formData.emailPrefix.trim()) {
    showValidationAlert('도메인을 입력해주세요.');
    return false;
  }

  if (!formData.emailDomain && !formData.emailDomainSelect) {
    showValidationAlert('도메인을 입력해주세요.');
    return false;
  }


  // Final email format validation
  const email = `${formData.emailPrefix}@${formData.emailDomain || formData.emailDomainSelect}`;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    showValidationAlert('올바른 이메일 형식을 입력해주세요');
    return false;
  }

   // Contact number validation (optional) - matching EditInfoPC.jsx pattern
   const contact = formData.contact;
   if (contact) {
     // Check length first
     if (contact.length > 10) {
       showValidationAlert('영문+숫자 10자리 미만');
       return false;
     }
     
     // Check if it contains combination of English letters and numbers
     if (!isAlphanumericCombination(contact)) {
       showValidationAlert('영문+숫자 10자리 미만');
       return false;
     }
   }
   
   // @NotBlank - Mobile phone validation (required field)
   const mobilePhone = `${formData.mobilePrefix}${formData.mobileMiddle}${formData.mobileEnd}`;
   if (!formData.mobileMiddle || !formData.mobileEnd) {
    showValidationAlert('휴대전화번호를 입력하세요. (8~11자 숫자 사용 가능)') 
       return;
   } else {
     const mobileRegex = /^\d{8,11}$/;
     if (!mobileRegex.test(mobilePhone)) {
       showValidationAlert('휴대전화번호를 입력하세요. (8~11자 숫자 사용 가능)');
       return;
     }
   }


      // @NotBlank - Address2 validation (required field)
      if (!formData.postCode?.trim()) {
        showValidationAlert('우편번호를 입력해주세요.');
        return false;
      }

      if (!formData.addressDetail1?.trim()) {
        showValidationAlert('우편번호를 입력해주세요.');
        return false;
      }

      if (!formData.addressDetail2?.trim()) {
        showValidationAlert('상세주소를 입력해주세요.(5~50자)');
        return false;
      }

      if (formData.addressDetail2.length < 5 || formData.addressDetail2.length > 50) {
        showValidationAlert('상세주소를 입력해주세요.(5~50자)');
        return false;
      }
      
      // @NotBlank - Gender validation (required field)
      if (!formData.gender) {
        showValidationAlert('성별을 선택해주세요.');
        return false;
      }
      
     
      
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Separate validation function that doesn't set state (for use in render)
  const isFormValid = () => {
    const newErrors = {};

    // Step 1 validation (Terms and Name)
    if (currentStep === 1) {
      if (!formData.termsAgreed) {
        newErrors.termsAgreed = '이용약관에 동의해주세요.';
      }
      if (!formData.privacyAgreed) {
        newErrors.privacyAgreed = '개인정보 수집·이용에 동의해주세요.';
      }
      if (!formData.name.trim()) {
        newErrors.name = '이름을 입력해주세요.';
      } else if (formData.name.length < 2) {
        newErrors.name = '이름은 2자 이상 입력해주세요.';
      } else {
        // Korean characters only validation
        const koreanRegex = /^[가-힣]+$/;
        if (!koreanRegex.test(formData.name.trim())) {
          newErrors.name = '이름은 한글만 입력해주세요.';
        }
      }
    }

    // Step 2 validation (Personal Information) - Based on Java @Valid annotations
    if (currentStep === 2) {
      // @NotBlank - User ID validation
      if (!formData.userId?.trim()) {
        newErrors.userId = '아이디를 입력해주세요.';
      } else if (formData.userId.length < 4) {
        newErrors.userId = '아이디는 4자 이상 입력해주세요.';
      } else if (!isDuplicateChecked) {
        newErrors.userId = '아이디 중복확인을 해주세요.';
      }
      
      // @NotBlank + @Size(min = 6, max = 10) - Password validation
      if (!formData.password) {
        newErrors.password = '비밀번호를 입력해주세요.';
      } else if (!isPasswordValid(formData.password)) {
        newErrors.password = '비밀번호는 6~10자, 영문·숫자·특수문자 조합';
      }
      
      // @NotBlank - Confirm password validation
      if (!formData.confirmPassword) {
        newErrors.confirmPassword = '비밀번호 확인을 입력해주세요.';
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = '비밀번호가 일치하지 않습니다.';
      }
      
      // @Email - Email validation (required)
      const email = `${formData.emailPrefix}@${formData.emailDomainSelect || formData.emailDomain}`;
      if (!formData.emailPrefix || !(formData.emailDomainSelect || formData.emailDomain)) {
        newErrors.email = '이메일을 입력해주세요.';
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          newErrors.email = '올바른 이메일 형식을 입력해주세요.';
        }
      }
      
      // @NotBlank - Address2 validation (required field)
      if (!formData.addressDetail2?.trim()) {
        newErrors.address2 = '상세주소를 입력해주세요.';
      }
      
      // @NotBlank - Gender validation (required field)
      if (!formData.gender) {
        newErrors.gender = '성별을 선택해주세요.';
      }
      
      // @Pattern(regexp = "\\d{8}") - Birth date validation
      if (formData.birthDate && formData.birthDate.length > 0) {
        const birthDateRegex = /^\d{8}$/;
        if (!birthDateRegex.test(formData.birthDate)) {
          newErrors.birthDate = '생년월일은 8자리 숫자로 입력해주세요. (예: 19800101)';
        }
      }
      
      // Contact number validation (optional) - matching EditInfoPC.jsx pattern
      const contact = formData.contact;
      if (contact) {
        // Check length first
        if (contact.length > 10) {
          showValidationAlert('영문+숫자 10자리 미만');
          return false;
        } else if (!isAlphanumericCombination(contact)) {
          showValidationAlert('영문+숫자 10자리 미만');
          return false;
        }
      }
      
      // @NotBlank - Mobile phone validation (required field)
      const mobilePhone = `${formData.mobilePrefix}${formData.mobileMiddle}${formData.mobileEnd}`;
      if (!formData.mobileMiddle || !formData.mobileEnd) {
        newErrors.mobilePhone = '휴대전화를 입력해주세요.';
      } else {
        const mobileRegex = /^\d{8,11}$/;
        if (!mobileRegex.test(mobilePhone)) {
          newErrors.mobilePhone = '휴대전화는 8-11자리 숫자로 입력해주세요.';
        }
      }
      
      // @NotBlank - Postal code validation (required field)
      if (!formData.postCode?.trim()) {
        newErrors.postCode = '우편번호를 입력해주세요.';
      }
      
      // @NotBlank - Address1 validation (required field)
      if (!formData.addressDetail1?.trim()) {
        newErrors.address1 = '주소를 입력해주세요.';
      }

      if (!formData.addressDetail2?.trim()) {
        newErrors.address2 = '주소를 입력해주세요.';
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    // Numeric validation for phone fields
    if (field === 'mobileMiddle' || field === 'mobileEnd' || field === 'birthDate') {
      // Only allow numeric input
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({
        ...prev,
        [field]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    
    // Handle email domain selection - populate the manual domain input when dropdown is selected
    if (field === 'emailDomainSelect') {
      if (value && value !== '직접 입력하기' && value !== '선택해주세요') {
        // When a domain is selected from dropdown, populate the manual domain input
        setFormData(prev => ({
          ...prev,
          emailDomainSelect: value,
          emailDomain: value // Also populate the manual domain input
        }));
      } else if (value === '직접 입력하기' || value === '선택해주세요' || value === '') {
        // When "직접 입력하기" or "선택해주세요" is selected, clear the manual domain input for user to type
        setFormData(prev => ({
          ...prev,
          emailDomainSelect: value,
          emailDomain: '' // Clear the manual domain input
        }));
      }
      return; // Exit early to avoid other processing
    }
    
    // Reset duplicate check if userId is changed
    if (field === 'userId') {
      setIsDuplicateChecked(false);
      setIdCheckResult("");
    }
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
    
    // Check for restricted names in both userId and name fields
    const restrictedNames = ['ganghwa', 'saswat', 'riya', 'test'];
    const inputValue = value.toLowerCase().trim();
    
    if (restrictedNames.includes(inputValue)) {
      showValidationAlert('사용할 수 없는 이름입니다. 다른 이름을 입력해주세요.');
      return false;
    }
  };

  // Handle ID duplication check
  const handleIdCheck = async () => {
    if (!formData.userId?.trim()) {
      setIdCheckResult("아이디를 입력해주세요.");
      setIsDuplicateChecked(false);
      return;
    }
    
    setIdCheckLoading(true);
    setIdCheckResult("");
    
    try {
      // API returns true if duplicate, false if available
      const isDuplicate = await AuthService.duplicateNicknameCheck({ nickname: formData.userId.trim() });
      
      if (isDuplicate) {
        setIdCheckResult("사용중인 아이디입니다. 다른 ID를 입력해주세요.");
        setIsDuplicateChecked(false);
      } else {
        setIdCheckResult("사용가능한 ID입니다.");
        setIsDuplicateChecked(true);
      }
    } catch (error) {
      setIdCheckResult("중복확인 중 오류가 발생했습니다. 다시 시도해주세요.");
      setIsDuplicateChecked(false);
    } finally {
      setIdCheckLoading(false);
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (field, checked) => {
    setFormData(prev => ({
      ...prev,
      [field]: checked
    }));
    
    // Clear error when user checks the box
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  // Handle next step
  const handleNextStep = async () => {
    if (!validateForm()) {
      return;
    }

    if (currentStep === 1) {
      setCurrentStep(2);
    } else if (currentStep === 2) {
      await handleSubmit();
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }
    
    setIsSubmitting(true);
    try {
      // Prepare data for API
      const email = `${formData.emailPrefix}@${formData.emailDomainSelect || formData.emailDomain}`;
      const phone = formData.contact;
      const handphone = `${formData.mobilePrefix}${formData.mobileMiddle}${formData.mobileEnd}`;
      const data = {
        nickname: formData.userId,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        bongandangId: 1, // Default to family columbarium
        name: formData.name,
        email,
        sex: formData.gender,
        birthday: formData.birthDate,
        phone,
        handphone,
        postCode: formData.postCode,
        address1: formData.addressDetail1,
        address2: formData.addressDetail2
      };
      // Call real API
      await register(data);
      
      // Only navigate to completion page if API call succeeds
      navigate('/signup-complete', { 
        state: { 
          userData: formData,
          message: '회원가입이 성공적으로 완료되었습니다.' 
        }
      });
    } catch (error) {
      console.error('Registration error:', error);
      // Show error message to user
      setErrors(prev => ({
        ...prev,
        global: error.response?.data?.message || '회원가입에 실패했습니다. 다시 시도해주세요.'
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle back to previous step
  const handleBackStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Check if current step is valid
  const isCurrentStepValid = () => {
    if (currentStep === 1) {
      return formData.termsAgreed && 
             formData.privacyAgreed && 
             formData.name.trim() && 
             formData.name.length >= 2 &&
             /^[가-힣]+$/.test(formData.name.trim());
    } else if (currentStep === 2) {
      // Check required fields for step 2 based on Java backend requirements
      const email = `${formData.emailPrefix}@${formData.emailDomainSelect || formData.emailDomain}`;
      const mobilePhone = `${formData.mobilePrefix}${formData.mobileMiddle}${formData.mobileEnd}`;
      
      return formData.userId?.trim() && 
             formData.userId.length >= 4 &&
             isDuplicateChecked &&
             formData.password && 
             isPasswordValid(formData.password) &&
             formData.confirmPassword && 
             formData.password === formData.confirmPassword &&
             formData.gender &&
             formData.mobileMiddle && 
             formData.mobileEnd &&
             /^\d{8,11}$/.test(mobilePhone) &&
             formData.postCode?.trim() &&
             formData.addressDetail1?.trim() &&
             formData.addressDetail2?.trim() &&
             formData.emailPrefix && (formData.emailDomainSelect || formData.emailDomain);
    }
    return true;
  };

  // Add Daum Postcode API integration
  React.useEffect(() => {
    if (!window.daum) {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const openPostcodePopup = () => {
    if (!window.daum || !window.daum.Postcode) {
      showValidationAlert("주소 검색 서비스를 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }
    new window.daum.Postcode({
      oncomplete: function(data) {
        // Fill postCode, address, and addressDetail1 automatically
        // addressDetail2 will remain empty for user input only
        setFormData(prev => ({
          ...prev,
          postCode: data.zonecode,
          address: data.roadAddress || data.jibunAddress,
          addressDetail1: data.roadAddress || data.jibunAddress,
          addressDetail2: "" // Keep empty for user input only
        }));
      }
    }).open();
  };

  return (
    <div className="signup-pc-page">
      
      
      <main className="signup-section" style={{
        backgroundImage: 'url("/images1/fe8abcfd1543ad4d14edd25847908cdd87ecd720.png")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: '100% auto'
      }}>
        <div className="container">
        {/* Page Title */}
        <CommonTitle heading="회원가입" />


        {/* Progress Steps */}
          <nav className="signup-steps">
            <div className={`step ${currentStep === 1 ? 'active' : ''}`}>약관동의</div>
            <div className={`step ${currentStep === 2 ? 'active' : ''}`}>정보 입력</div>
            <div className={`step ${currentStep === 3 ? 'active' : ''}`}>가입 완료</div>
          </nav>

          {/* Form Wrapper */}
          <div className="form-wrapper">
            {/* Welcome Message */}
            <h2 className="welcome-message">
              <strong>파라다이스 추모원 회원가입</strong>을 환영합니다.
            </h2>

            <form onSubmit={(e) => e.preventDefault()}>
              {/* Step 1: Terms and Name */}
              {currentStep === 1 && (
                <>
                <div className="terms-box-container">

                  {/* Terms Box */}
                  <div className="terms-box">
                    <header className="terms-header">
                      <h3>이용약관</h3>
                      <label className="checkbox-container">
                        <input 
                          type="checkbox" 
                          className="visually-hidden"
                          checked={formData.termsAgreed}
                          onChange={(e) => handleCheckboxChange('termsAgreed', e.target.checked)}
                        />
                        <div className="custom-checkbox">
                          <img src="/images1/3_295.svg" alt="checkbox background" className="checkbox-bg" />
                          <img src="/images1/3_296.svg" alt="checkmark" className="checkmark" style={{ opacity: formData.termsAgreed ? '1' : '0' }} />
                        </div>
                        <span>동의함</span>
                      </label>
                    </header>
                    <div className="terms-content">
                      <p>아래의 이용약관은 강화파라다이스를 이용하시는 고객님의 권익 보호와 공정한 거래를 위해 제정되었습니다.고객님의 입장에 서서 최대한 안전하고 편리한 쇼핑 서비스를 제공하기 위해 노력하겠습니다.</p>
                      <p><strong>약관</strong> (공정거래위원회 표준약관 제10023호)</p>
                      <p className="section-title">제1장 총 칙</p>
                      <p><strong>제1조(목적)</strong> 이 약관은 (이하 "회사"라 한다)의 회원약관에 동의한 모든 회원 및 비회원들을 대상으로 하며, "회사"가 운영하는 웹사이트에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 웹사이트 과 이용자의 권리의무 및 책임사항을 규정함을 목적으로 합니다.</p>
                      <p><strong>제2조(정의)</strong></p>
                      <ol>
                        <li>웹사이트 : "회사"가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장 혹은 웹사이트을 운영하는 사업자</li>
                        <li>이용자 : "웹사이트"에 접속하여 이 약관에 따라 "웹사이트"가 제공하는 서비스를 받는 회원 및 비회원</li>
                        <li>회원 : "웹사이트"의 회원약관에 동의하여 "회사"에 개인정보를 제공하여 이용계약을 체결한 모든 회원을 지칭하며, "웹사이트"의 정보를 지속적으로 제공받으며, "웹사이트"가 제공하는 서비스를 계속적으로 이용할 수 있는 자</li>
                        <li>비회원 : 회원에 가입하지 않고 "웹사이트"가 제공하는 서비스를 이용하는 자</li>
                      </ol>
                    </div>
                    {errors.termsAgreed && <div className="error-message">{errors.termsAgreed}</div>}
                  </div>

                  {/* Privacy Box */}
                  <div className="terms-box">
                    <header className="terms-header">
                      <h3>개인정보 수집·이용안내</h3>
                      <label className="checkbox-container">
                        <input 
                          type="checkbox" 
                          className="visually-hidden"
                          checked={formData.privacyAgreed}
                          onChange={(e) => handleCheckboxChange('privacyAgreed', e.target.checked)}
                        />
                        <div className="custom-checkbox">
                          <img src="/images1/3_301.svg" alt="checkbox background" className="checkbox-bg" />
                          <img src="/images1/3_302.svg" alt="checkmark" className="checkmark" style={{ opacity: formData.privacyAgreed ? '1' : '0' }} />
                        </div>
                        <span>동의함</span>
                      </label>
                    </header>
                    <div className="terms-content">
                      <p><strong>개인정보의 수집,이용목적</strong></p>
                      <ol>
                        <li>서비스 이용에 따른 본인식별, 실명확인, 가입의사확인, 연령제한 서비스이용</li>
                        <li>고지사항 전달, 불만처리 의사소통 경로 확보, 물품배송 시 정확한 배송지 정보 확보</li>
                        <li>신규 서비스등 최신정보 안내 및 개인맞춤서비스 제공을 위한 자료</li>
                        <li>유료정보 이용에 대한 요금결제</li>
                        <li>불량회원 부정이용 방지 및 비인가 사용방지</li>
                        <li>기타 원활한 양질의 서비스 제공등</li>
                      </ol>
                    </div>
                    {errors.privacyAgreed && <div className="error-message">{errors.privacyAgreed}</div>}
                  </div>

                  {/* Name Input */}
                  <div className="input-group">
                    <label htmlFor="user-name" className="input-label">이름/실명 입력</label>
                    <input 
                      type="text" 
                      id="user-name" 
                      name="username" 
                      placeholder="홍길동"
                      value={formData.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      style={{
                        border: 'none',
                        fontSize: '24px',
                        color: formData.name ? '#222222' : '#999999',
                        width: '200px',
                        textAlign: 'right',
                        outline: 'none',
                        background: 'transparent',
                        padding: '6px 0',
                        cursor: 'text'
                      }}
                    />
                  </div>
                  {errors.name && <div className="error-message">{errors.name}</div>}
                  </div>
                </>
              )}

              {/* Step 2: Personal Information */}
              {currentStep === 2 && (
                <div className="personal-info-form">
                  <div className="form-header">
                    <span className="required-note">* 기본(필수)정보 입력</span>
                  </div>

                  {/* ID Field */}
                  <div className="form-row">
                    <div className="flex-column">
                    <div className="form-group">
                      <label>아이디<span className="required-asterisk">*</span></label>
                      <input 
                        type="text" 
                        name="nickname" 
                        value={formData.userId || ''} 
                        onChange={(e) => handleInputChange('userId', e.target.value)}
                        required 
                        placeholder="아이디를 입력하세요"
                      />
                      <button 
                        type="button" 
                        className="check-btn" 
                        onClick={handleIdCheck} 
                        disabled={idCheckLoading || !formData.userId?.trim()}
                        style={{
                          marginTop: '5px',
                          marginLeft: '11px',
                          padding: '8px 16px',
                          backgroundColor: '#666',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px',
                          fontSize: '14px',
                          cursor: 'pointer'
                        }}
                      >
                        {idCheckLoading ? "확인 중..." : "중복확인"}
                      </button>
                      {idCheckResult && (
                        <div className="check-result" style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: '10px',
                          color: idCheckResult.includes('가능') ? '#1abc9c' : '#e74c3c',
                          fontSize: '0.9rem', 
                          marginLeft: '10px'
                        }}>
                          {idCheckResult.includes('가능') && (
                            <span style={{ 
                              display: 'inline-block',
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              border: '1px solid #1abc9c',
                              textAlign: 'center',
                              lineHeight: '14px',
                              fontSize: '10px',
                              marginRight: '5px',
                              color: '#1abc9c'
                            }}>✔</span>
                          )}
                          {idCheckResult}
                        </div>
                      )}
                      </div>
                      
                    </div>
                  </div>

                  {/* Password Field */}
                  <div className="form-row">
                    <div className="form-group">
                     
                      <label htmlFor="password">비밀번호 <span className="required-asterisk">*</span></label>
                      <div className="flex-column">
                        <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
                      <input 
                        type="password" 
                        id="password" 
                        value={formData.password}
                        onChange={(e) => handleInputChange('password', e.target.value)}
                        placeholder="비밀번호를 입력하세요"
                      />
                      <div className="instruction-text">6~10자 영문, 숫자, 특수기호 사용 가능</div>
                      </div>
                     
                    </div>
                    </div>
                  </div>

                  {/* Confirm Password Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="confirmPassword">비밀번호 확인 <span className="required-asterisk">*</span></label>
                      <div className="flex-column">
                      <div>
                      <input 
                        type="password" 
                        id="confirmPassword" 
                        value={formData.confirmPassword}
                        onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                        placeholder="비밀번호를 다시 입력하세요"
                      />
                      {formData.confirmPassword && (
                        <div className={`instruction-text ${formData.password === formData.confirmPassword ? "success" : "error"}`}>
                          {formData.password === formData.confirmPassword ? "비밀번호가 일치합니다" : "비밀번호가 일치하지 않습니다"}
                        </div>
                      )}
                      </div>
                  
                      </div>
                    </div>
                  </div>

                  {/* Columbarium Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="columbarium">봉안당</label>
                      <select 
                        id="columbarium" 
                        value={formData.columbarium || 1}
                        onChange={(e) => handleInputChange('columbarium', e.target.value)}
                      >
                        {places.map((place) => (
                          <option key={place.id} value={place.id}>{place.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Name Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">이름(실명) <span className="required-asterisk">*</span></label>
                      <input 
                        type="text" 
                        id="name" 
                        value={formData.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        placeholder="실명을 입력하세요"
                        disabled
                      />
                    </div>
        </div>

                  {/* Email Field */}
                  <div className="form-row">
                    <div  className="form-group">
                      <label htmlFor="email">이메일 <span className="required-asterisk">*</span></label>
                      <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                      <div className="email-input-group">
                        <input 
                          type="text" 
                          id="emailPrefix" 
                          value={formData.emailPrefix || ''}
                          onChange={(e) => handleInputChange('emailPrefix', e.target.value)}
                          placeholder="이메일"
                        />
                        <span className="email-separator">@</span>
                        <input 
                          type="text" 
                          id="emailDomain" 
                          value={formData.emailDomain || ''}
                          onChange={(e) => handleInputChange('emailDomain', e.target.value)}
                          placeholder="도메인"
                          disabled={formData.emailDomainSelect !== '선택해주세요' && formData.emailDomainSelect !== '직접 입력하기' && formData.emailDomainSelect !== ''}
                          className={formData.emailDomainSelect !== '선택해주세요' && formData.emailDomainSelect !== '직접 입력하기' && formData.emailDomainSelect !== '' ? 'disabled-input' : ''}
                        />
                        <select 
                          id="emailDomainSelect" 
                          value={formData.emailDomainSelect || ''}
                          onChange={(e) => handleInputChange('emailDomainSelect', e.target.value)}
                        >
                          <option value="">선택해주세요</option>
                          <option value="gmail.com">gmail.com</option>
                          <option value="naver.com">naver.com</option>
                          <option value="daum.net">daum.net</option>
                          <option value="hanmail.net">hanmail.net</option>
                          <option value="nate.com">nate.com</option>
                          <option value="paran.comdreamwiz.com">paran.comdreamwiz.com</option>
                          <option value="hotmail.com">hotmail.com</option>
                          <option value="lycos.co.kr">lycos.co.kr</option>
                          <option value=" freechal.com">freechal.com</option>
                          <option value="hanafos.comkorea.com">hanafos.comkorea.com</option>
                          <option value="hanmir.com">hanmir.com</option>
                          <option value="empal.com">empal.com</option>
                          <option value="직접 입력하기">직접 입력하기</option>
                        </select>                        

                      </div>
                      </div>
                    </div>
            </div>

                  {/* Gender Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="gender">성별</label>
                      <div className="flex-column">
                      <div>
                      <div className="radio-group">
                        <fieldset className="gr-fieldset">
                          <legend className="gr-legend">성별</legend>

                          {/* 남 */}
                          <div className="gr-option">
                            <input
                              type="radio"
                              id="gender-male"
                              name="gender"
                              value="남"
                              checked={formData.gender === '남'}
                              onChange={(e) => handleInputChange('gender', e.target.value)}
                              className="gr-input"
                            />
                            <label htmlFor="gender-male" className="gr-label">
                              <span style={{color: '#666666'}}>남</span>
                            </label>
                          </div>

                          {/* 여 */}
                          <div className="gr-option">
                            <input
                              type="radio"
                              id="gender-female"
                              name="gender"
                              value="여"
                              checked={formData.gender === '여'}
                              onChange={(e) => handleInputChange('gender', e.target.value)}
                              className="gr-input"
                            />
                            <label htmlFor="gender-female" className="gr-label">
                             <span style={{color: '#666666'}}>여 </span>

                            </label>
                          </div>
                        </fieldset>
                      </div>
                   </div>
                      
                     
                      </div>
                      </div>
                    </div>
                  {/* </div> */}

                  {/* Birth Date Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="birthDate">생년월일</label>
                      <input 
                        type="text" 
                        id="birthDate" 
                        value={formData.birthDate || ''}
                        onChange={(e) => handleInputChange('birthDate', e.target.value)}
                        placeholder="예) 19800101"
                        maxLength="8"
                        inputMode="numeric"
                      />
                      <div style={{marginLeft:'10px'}} className="instruction-text">예) 19800101</div>
                    </div>
                  </div>

                  {/* Contact Number Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="contactNumber">연락처</label>
                      <div className="flex-row">
                        <input 
                          type="text" 
                          id="contactNumber" 
                          value={formData.contact || ''}
                          onChange={(e) => handleInputChange('contact', e.target.value)}
                          placeholder="영문과 숫자 조합으로 입력하세요"
                        />
                        <div className="instruction-text">영문+숫자 10자리 미만</div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Phone Field */}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="mobilePhone">휴대전화 <span className="required-asterisk">*</span></label>
                      <div className="flex-column">
                     
                      <div className="phone-input-group">
                        <select 
                          id="mobilePrefix" 
                          value={formData.mobilePrefix || '010'}
                          onChange={(e) => handleInputChange('mobilePrefix', e.target.value)}
                        >
                          <option value="010">010</option>
                          <option value="011">011</option>
                          <option value="016">016</option>
                          <option value="017">017</option>
                          <option value="018">018</option>
                          <option value="019">019</option>
                        </select>
                        <span className="phone-separator">-</span>
                        <input 
                          type="text" 
                          id="mobileMiddle" 
                          value={formData.mobileMiddle || ''}
                          onChange={(e) => handleInputChange('mobileMiddle', e.target.value)}
                          placeholder="1234"
                          maxLength="4"
                          inputMode="numeric"
                        />
                        <span className="phone-separator">-</span>
                        <input
                          type="text" 
                          id="mobileEnd" 
                          value={formData.mobileEnd || ''}
                          onChange={(e) => handleInputChange('mobileEnd', e.target.value)}
                          placeholder="5678"
                          maxLength="4"
                          inputMode="numeric"
                        />
            </div>
          
            </div>
          
          </div>
        </div>

                  {/* Address Field */}
                  <div className="form-row"                  >
                    <div className="form-group">
                      <label htmlFor="address">주소 <span className="required-asterisk">*</span></label>
                      <div className="flex-column">
                      <div className="signup-pc-address-container">
                        <div className="signup-pc-address-row">
                          <input 
                            type="text" 
                            id="postCode" 
                            className="signup-pc-address-input"
                            value={formData.postCode || ''}
                            onChange={(e) => handleInputChange('postCode', e.target.value)}
                          />
                          <button 
                            type="button" 
                            className="signup-pc-postal-btn"
                            onClick={openPostcodePopup}
                          >
                            우편번호
                          </button>
                        </div>
                        <div className="signup-pc-address-detail-row">
                          <input
                            type="text"
                            id="addressDetail1" 
                            className="signup-pc-address-detail-input"
                            value={formData.addressDetail1 || ''}
                            onChange={(e) => handleInputChange('addressDetail1', e.target.value)}
                          />
                          <input
                            type="text"
                            id="addressDetail2" 
                            className="signup-pc-address-detail-input"
                            value={formData.addressDetail2 || ''}
                            onChange={(e) => handleInputChange('addressDetail2', e.target.value)}
                          />
                        </div>
                      </div>
                    
                      </div>

                    </div>
                  </div>
                </div>
              )}

              {/* Global Error Message */}
              {errors.global && <div className="error-message global-error">{errors.global}</div>}

              {/* Navigation Buttons */}
              <div className="signup-pc-button-container">
                {currentStep === 1 && (
                  <button 
                    type="button" 
                    className="submit-button"
                    onClick={handleNextStep}
                    disabled={!isCurrentStepValid() || isSubmitting}
                  >
                    {isSubmitting ? '처리중...' : '다음단계'}
                  </button>
                )}
                
                {currentStep === 2 && (
                  <>
                    <button 
                      type="button" 
                      className="signup-pc-cancel-btn"
                      onClick={() => navigate('/')}
                      disabled={isSubmitting}
                    >
                      취소
                    </button>
                    <button 
                      type="button" 
                      className="signup-pc-submit-btn"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? '처리중...' : '가입완료'}
                    </button>
                  </>
                )}
              </div>
            </form>


          </div>
        </div>
      </main>

      
    </div>
  );
}

export default SignupPC; 